import { Component, OnInit } from '@angular/core';
import { BasePage } from '../../base-page';
import { BartenderModel } from 'src/app/models/bartenders/bartender.model';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'src/app/services/message.service';
import { StoreInfoModel, StoreModel } from 'src/app/models/store/store.model';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';

@Component({
    selector: 'app-edit-bartender',
    templateUrl: './edit-bartender.component.html',
    styleUrls: ['./edit-bartender.component.scss'],
    standalone: false
})
export class EditBartenderComponent extends BasePage implements OnInit {

  public model: BartenderModel = {
    store: {
      address: '',
      name: ''
    },
  };

  public stores: StoreModel[] = [];

  constructor(private mApiService: ApiService, private mRouter: Router, private mMessageService: MessageService, activatedRoute: ActivatedRoute) {
    super();
    this.model.id = activatedRoute.snapshot.params['id'] !== 'new' ? activatedRoute.snapshot.params['id'] : undefined;
  }


  ngOnInit(): void {
    this.isBusy = true;
    const loadingStack = [0, 0];
    if (this.model.id) {
      this.mApiService.get<BartenderModel>(`/api/admin/bartender/${this.model.id}`).subscribe({
        next: r => {
          this.model = r;
          loadingStack.pop();
          this.isBusy = loadingStack.length != 0;
        }, error: () => {
          loadingStack.pop();
          this.isBusy = loadingStack.length != 0;
        }
      });
    } else {
      loadingStack.pop();
      this.isBusy = loadingStack.length != 0;
    }

    this.mApiService.getWithParams<PagedSearchModel<string>, PagedResponseModel<StoreModel>>('/api/admin/store/list', {
      page: 1,
      pageSize: 100000,
      search: undefined
    }).subscribe({
      next: (r) => {
        this.stores = r.items;
        if (r.items.length > 0 && !this.model.store?.id) {
          this.model.store!.id = r.items[0].id!;
        }
        loadingStack.pop();
        this.isBusy = loadingStack.length != 0;
      }, error: () => {
        loadingStack.pop();
        this.isBusy = loadingStack.length != 0;
      }
    });
  }

  public save() {

    this.isBusy = true;


    this.mApiService.post<BartenderModel, BartenderModel>('/api/admin/bartender', this.model).subscribe({
      next: r => {
        this.isBusy = false;

        if (!this.model.id) {
          this.mRouter.navigate([`/bartender/edit/${r.id}`]);
        }

        this.model = r;
        this.mMessageService.addMessage({ text: 'Бармен сохранен', type: this.mMessageService.types.success });
      }, error: () => this.isBusy = false
    });
  }

  public getImageStyle() {
    if (this.model.imagePath) {
      return {
        'background-image': `url(/${this.model.imagePath})`
      };
    }
    return { '': '' }
  }

  public selectFile(event: any) {
    if (!event.target.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    this.isBusy = true;

    this.mApiService.formData<{ url: string }>('/api/admin/bartender/image/save', formData).subscribe({
      next: (r) => {
        this.model.imagePath = r.url;
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

}
